var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"al-t-installation"},[(_vm.step == '1')?_c('al-t_1'):(_vm.step == '2')?_c('al-t_2'):(_vm.step == '3')?_c('al-t_3'):(_vm.step == '4')?_c('al-t_4'):(_vm.step == '5')?_c('al-t_5'):(_vm.step == '6')?_c('al-t_6'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }